import {
  createActions,
  createReqConsts,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('programs', 'acceptConsent', ['INIT']);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  slug: [
    { type: 'payload', selector: ['userId'] },
    'programs',
    { type: 'payload', selector: ['programId'] },
    'consents',
    { type: 'payload', selector: ['consentId'] },
    'assignments',
  ],
  type: 'post',
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/programs/acceptConsent.js